import React from 'react';
import { Card } from 'react-bootstrap';
import { timeConverter } from './../../utils/NiceStrings'
import { getPlayerStoryList } from '../../components/webContentRequests';


const SubmittedStoriesCard = ({ stories }) => {
    return (
        <Card className={"m-2 score-card-eom-overview"} >
            <Card.Header className={"going-on-header"}>
                <Card.Title>Recently Submitted Stories</Card.Title>
            </Card.Header>
            <Card.Body>
                {stories.map((story, index) =>
                    <div key={index} className="divtext pb-2">
                        <a className="dryLink" href={`/player/stories/${story.story_id}`}>
                            {story.story_status === 'SUBMITTED' ?
                                <span className={"mx-1 px-2 badge text-bg-danger"}>
                                    pending
                                </span>
                                : null}
                            <span>{story.story_title}</span>

                            <br />
                            <small className="m-4">{story.story_owner} - {timeConverter(story.story_publishdate)}</small>
                        </a>
                    </div>
                )}
            </Card.Body>
        </Card>

    );
}

const getStoryList = async (setRecentStories) => {
    const data = await getPlayerStoryList();
    if (data.result) {
        data.stories.sort((a, b) => b.story_publishdate - a.story_publishdate);

        let filteredList = data.stories.filter(story =>
            (story.story_status == 'SUBMITTED') ||
            (story.story_status == 'APPROVED')

        );
        filteredList = filteredList.slice(0, 10);
        setRecentStories(filteredList);
    }
}

export { SubmittedStoriesCard, getStoryList };